import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getShortLink } from 'cityads-v3/actions/shortLink'

import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined'
import TextField from 'cityads-v3/components/TextField/TextField';
import IconCompress from './icons/Compress';

@connect(
  (state, props) => ({
    shortLink: state.shortLink.shortLinks[props.value],
    shortLinkLoading: state.shortLink.isLoading[props.value],
    shortLinkLoaded: state.shortLink.isLoaded[props.value],
  })
)
export default class CopyTextField extends Component {
  static propTypes = {
    copyButtonTitle: PropTypes.string,
    value: PropTypes.string,
    onCopyText: PropTypes.func,
    useShortener: PropTypes.bool,
    isShortLink: PropTypes.bool,
    copyOnFocus: PropTypes.bool,
    onChangeIsShort: PropTypes.func,
  }

  constructor(props) {
    super(props);

    this.textInput = React.createRef();
  }

  state = {
    isShortLink: this.props.isShortLink ?? false
  }

  componentDidUpdate(prevProps) {
    const { shortLinkLoaded, value, isShortLink, onChangeIsShort } = this.props;

    if (shortLinkLoaded && !prevProps.shortLinkLoaded) {
      this.setState({
        isShortLink: true
      });
      onChangeIsShort?.(true)
    }

    if (value !== prevProps.value) {
      this.setState({
        isShortLink: false
      })
      onChangeIsShort?.(false)
    }

    if (typeof isShortLink === 'boolean' && prevProps.isShortLink !== isShortLink) {
      this.setState({
        isShortLink
      });
      onChangeIsShort?.(isShortLink)
    }
  }

  handleClickCopyIcon = () => {
    if (this.props.copyOnFocus) {
      this.textInput.current?.select()
    } else {
      this.copyText()
    }
  }

  copyText = () => {
    const textInput = this.textInput.current;

    if (!textInput) { return; }

    textInput.select();
    document.execCommand('copy');

    const { onCopyText } = this.props;

    if (onCopyText) {
      onCopyText();
    }
  }

  shortLink = () => {
    const { value, dispatch, onChangeIsShort } = this.props;
    if (this.state.isShortLink) {
      this.setState({
        isShortLink: false
      });
      onChangeIsShort?.(false);
    } else {
      dispatch(getShortLink(value, value));
    }
  }

  render() {
    const {
      copyButtonTitle,
      InputProps,
      InputLabelProps,
      onCopyText,
      useShortener,
      shortLink,
      isShortLink: isShortLinkProp,
      copyOnFocus,
      onChangeIsShort,
      value,
      dispatch,
      shortLinkLoaded,
      shortLinkLoading,
      ...rest
    } = this.props;
    const { isShortLink } = this.state;

    return (
      <TextField
        {...rest}
        value={isShortLink ? shortLink : value}
        fullWidth
        readOnly
        inputRef={this.textInput}
        onFocus={rest.onFocus ?? (copyOnFocus ? this.copyText : undefined)}
        InputProps = {{
          ...InputProps,
          endAdornment: (
            <InputAdornment position={'end'}>
              {useShortener && (
                <IconButton title={copyButtonTitle} onClick={this.shortLink} size="small">
                  <IconCompress />
                </IconButton>
              )}
              <IconButton title={copyButtonTitle} onClick={this.handleClickCopyIcon} size="small">
                <FileCopyOutlinedIcon />
              </IconButton>
            </InputAdornment>
          )
        }}
        InputLabelProps = {{
          shrink: true,
          ...InputLabelProps,
        }}
      />
    );
  }
}
